import React from "react";

export default () => (
  <section>
    <p>Please create some models first...</p>
  </section>
);
